module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/diffuser@2x_c8c87e.png";